/* istanbul ignore file */
import React, { useEffect, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect } from 'react-redux';

import { createStructuredSelector } from 'reselect';
import _, { isNil } from 'lodash';
import { get, isEmpty } from 'lodash';
import {
  Container,
  SahamTabsGlobal,
  StyledTopDiv,
} from 'containers/CourtManagerLegalProceedings/styled-components';
import { rcCoporeal } from 'containers/CourtManagerLegalProceedings/JudgementAdd/constants';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import AssignmentClaimDrawer from 'components/AssignmentClaimDrawer';
import GlobalLegalProceedingTabs from 'components/GlobalLegalProceedingTabs';
import useCollapse from 'hooks/useCollapse';
import {
  makeSelectCurrentInstanceTab,
  makeSelectCurrentTabManager,
  makeSelectLinkToBeneficiaryCodes,
  makeSelectListings,
  makeSelectGlobalCurrentTabManager,
  makeSelectCurrentTabJudiciaryProcessManager,
  makeSelectNotificationsInboxes,
  makeSelectCurrentTabIndexExpertise,
} from 'containers/AppContainer/selectors';
import { makeSelecClaimRecap } from 'containers/RecapManagerPage/selectors';
import {
  requestAssigment,
  requestClaimRecap,
  requestUpdateVictimInfo,
  requestUpdateBeneficiaryInfo,
  requestUpdateVehicleInfo,
  setClaimRecap,
  requestValidateProvisionIntervenant,
  resetStoreClaim,
} from 'containers/RecapManagerPage/actions';
import {
  requestSearchClaims,
  resetSearchClaimsStore,
} from 'containers/IdentificationPage/actions';
import { makeSelectSearchClaims } from 'containers/IdentificationPage/selectors';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { translate } from 'containers/services/translate';
import {
  makeSelectExpertiseRaport,
  makeSelectJudgementAdd,
  makeSelectJudgementOnMerits,
  makeSelectJudgementAppeal,
  makeSelectDahirAmounts,
  makeSelectDahirAmountsCorpo,
  makeSelectJudgementOnMeritsAppeal,
  makeSelectExpertiseRaportAppeal,
  makeSelectJudgementAddAppeal,
  makeSelectJudgementOnMeritsMultiple,
  makeSelectAppealOnMeritsMultiple,
} from 'containers/LawyerLegalProceedingsPage/selectors';
import {
  requestGetJudgementAdd,
  requestGetDahirAmount,
  requestCreateJudgementOnMeritsContestation,
  requestGetJudgementOnMeritsAppeal,
  requestGetExpertiseReportAppeal,
  requestGetJudgementAddAppeal,
  updateContestation,
  requestUploadContestationDocument,
  requestGetJudgementOnMeritsMultiple,
  requestGetAppealOnMeritsMultiple,
  setLockedClaim,
  resetLegalProceeding,
} from 'containers/LawyerLegalProceedingsPage/actions';
import {
  requestMakeJudgementAddDecision,
  requestValidateExpertReport,
  requestValidateJudgementOnMerits,
  requestValidateJudgementAppeal,
  requestCreateCivilProceeding,
  requestAssignedExpert,
  requestValidateDisclaimerWarranty,
  requestUpdatedCivilProceeding,
  requestValidatedCivilProceeding,
  requestMakeJudgementAddDocumentDecision,
  requestAddVictims,
  requestAddVehicles,
  requestMakeDecisionMissionExpertise,
  requestMakeDecisionMissionNoticeDeficiency,
  requestIsSuspiciosClaim,
  requestCreateJudgementAdd,
  requestLockClaim,
  requestUnlockClaim,
  requestMakeDecisionsDocumentImaging,
  requestGetClaimHistoryActions,
  setDecisionsJudgementIds,
  requestGetClaimHistorySagis,
  requestSetStatusClaimSagis,
  requestResetHistoryStore,
  requestGetPendingTasksClaim,
} from 'containers/CourtManagerLegalProceedings/actions';
import {
  IAppealPayload,
  ICurrentSteps,
  IJudgementAdd,
  IUploadedDocument,
  JudgementOnMeritsType,
} from 'containers/LawyerLegalProceedingsPage/typings';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import {
  requestAddTransaction,
  requestGetTransaction,
  requestUpdateTransaction,
  requestAddContactTransaction,
  requestGetContactTransaction,
  resetStoreTransaction,
  requestUpdateContactTransaction,
  requestGetMissionTransaction,
  requestGetMissionVictimExpertise,
  requestUpdateMissionTransaction,
  requestGetFeeNotesTransaction,
} from 'containers/TransactionManagerTimeLine/actions';
import { getLegalProceedingsSteps } from 'containers/LawyerAssignmentsPage/actions';
import { makeSelectLegalProceedingsSteps } from 'containers/LawyerAssignmentsPage/selectors';
import {
  requestGetExpertiseRaport,
  requestGetJudgementOnMerits,
  requestGetJudgementAppeal,
  requestCreateMultipleJudgementAdd,
  requestGetDahirAmountCorpo,
  requestCreateExpertiseRaport,
  requestAddSupportDocument,
  requestCivilPartySupportDocument,
  requestAddExpertiseSupportDocument,
  requestAddJudgementOnMeritsSupportDocument,
} from 'containers/LawyerLegalProceedingsPage/actions';
import { ExpertReportType } from 'containers/common/LegalProceedings/ExpertReport/typings';
import ImagineDocumentsDrawer from 'containers/CourtManagerLegalProceedings/ImagineDocuments';
import {
  uploadDocument,
  resetUploadDocumentStore,
  setDocumentId,
} from 'containers/UploadDocuments/actions';
import {
  requestCreateFeeNote,
  requestUpdateFeeNoteStatus,
  requestUpdateFirmReferenceManager,
  requestUpdateInvoiceFeeNote,
} from 'containers/LawyerFeeNote/actions';
import {
  requestCreateFeeNoteManager,
  requestManagerFeeNotes,
} from 'containers/ManagerFeeNote/actions';
import { requestFeeNoteExceptionalCosts } from 'containers/ManagerFeeNote/actions';
import { requestCorporealLawyers } from 'containers/RecapManagerPage/actions';
import {
  makeSelectDocument,
  makeSelectDocumentId,
} from 'containers/UploadDocuments/selectors';
import {
  makeSelectCountFeeNotes,
  makeSelectFeeNotes,
  makeSelectAllFeeNotes,
} from 'containers/LawyerFeeNote/selectors';
import { makeSelectCivilProceeding } from 'containers/LawyerLegalProceedingsPage/selectors';
import { requestCreateJudgementOnMerits } from 'containers/LawyerLegalProceedingsPage/actions';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { FeeNote } from 'containers/LawyerFeeNote/typings';
import DialogFeeNote from 'components/DialogFeeNote';
import {
  requestFeeNotesByClaimNumb,
  requestAllFeeNotes,
} from 'containers/ManagerFeeNote/actions';
import { makeDecisionFeeNote } from 'containers/ManagerFeeNote/actions';
import { requestGetCivilProceeding } from 'containers/LawyerLegalProceedingsPage/actions';
import {
  requestGetNotificationsInboxes,
  setCurrentInstanceTab,
  setCurrentIndexTabTransaction,
} from 'containers/AppContainer/actions';
import { makeSelectCorporealLawyers } from 'containers/RecapManagerPage/selectors';
import ManagerLegalProceedingsPage from 'containers/ConsultationLegalProceedingPage/legalProceedings';
import { requestAddInvoiceFeeNote } from 'containers/LawyerFeeNote/actions';
import {
  requestSagisClaimInfo,
  requestGetJudgementOnMeritsByVictims,
  requestGetJudgementOnMeritsByVehicles,
  requestCreateCorpoEncryptedDocument,
  requestCreateCorporealRegulation,
  requestCreateMaterialRegulation,
  requestCreateAdditionalWarrentiesRegulation,
  requestMaterialEncryptedDocument,
  requestGetAssignedLawyers,
  requestGetRegulations,
  resetSagisInfoClaim,
  requestCreateSummarySheetRegulation,
  uploadDocumentRegulation,
  requestValidateProvision,
} from 'containers/CourtManagerLegalProceedings/Provision/redux/actions';
import {
  makeSelectSagisClaim,
  makeSelectJudgementOnMeritsByVictims,
  makeSelectJudgementOnMeritsByVehicles,
  makeSelectEncryptedDocuments,
  makeSelectMaterialEncryptedDocuments,
  makeSelectAssignedLawyers,
  makeRegulations,
  makeCreatedRegulations,
} from 'containers/CourtManagerLegalProceedings/Provision/redux/selectors';
import {
  PROVISION_TAB_LABELS,
  REGULATION_TAB_LABELS_CONSULTATION,
} from 'containers/CourtManagerLegalProceedings/constants';
import {
  claimTabs,
  filterFeeNotes,
} from 'containers/CourtManagerLegalProceedings/utils';
import { TopCard } from 'containers/CourtManagerLegalProceedings/TopCard';
import JudiciaryProcessTabs from 'components/JudiciaryProcessTabs';
import LegalProceedingTabs from 'components/LegalProceedingTabs';
import ProvisionContainer from 'containers/CourtManagerLegalProceedings/Provision';
import ExpertiseExpert from 'containers/CourtManagerLegalProceedings/ExpertiseExpert';
import { requestGetExpertiseVictim } from 'containers/ExpertExpertise/actions';
import {
  resolveSagisClaim,
  shouldShowVictimExcludedWarning,
} from 'helpers/utils';
import { requestUpdateFeeNoteAmount } from 'containers/LawyerFeeNote/actions';
import RegulationRecapContainer from 'containers/CourtManagerLegalProceedings/Provision/Regulation/RegulationRecapContainer';
import { makeSelectVictimExpertise } from 'containers/ExpertExpertise/selectors';
import { selectedLoader } from 'containers/AppContainer/Loader/selectors';
import SuspiciousCard from 'containers/CourtManagerLegalProceedings/SuspiciousCard';
import { AssignedLawyer } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/typings';
import { requestUpdateClaim } from 'containers/PreOpeningPage/actions';
import {
  makeSelectClaimHistoryActions,
  makeSelectDecisionJudgmentIds,
  makeSelectClaimHistorySagis,
  makeSelectPendingTasksClaim,
} from 'containers/CourtManagerLegalProceedings/selectors';
import ClaimRecap from 'containers/ConsultationLegalProceedingPage/ClaimRecap';
import TrackingActionDrawer from 'containers/CourtManagerLegalProceedings/TrackingActionDrawer';
import TransactionConsultation from 'containers/ConsultationLegalProceedingPage/Transaction';
import { requestGetReportsPolicy } from 'containers/UploadDocuments/actions';
import WarningCard from 'containers/common/Card/WarningCard';
import { requestGetDocByDocumentumId } from 'containers/common/UploadDocument/actions';
import { requestGetJudgements } from 'containers/common/LegalProceedings/actions';
import { ClaimRecapType } from 'typings/claimTypes';

export interface ConsultationLegalProceedingPageProps {
  intl: IntlShape;
  listings: Listings;
  storedClaimToPreopen: any;
  requestClaimRecap: Function;
  getLegalProceedingsSteps: Function;
  claimRecap: ClaimRecapType;
  currentSteps: ICurrentSteps[];
  policyInfo: { sagis: { claims: any } };
  requestSearchClaims: Function;
  resetSearchClaimsStore: Function;
  match: { params: { claimId: number } };
  requestGetJudgementAdd: Function;
  judgementAdd: IJudgementAdd;
  requestMakeJudgementAddDecision: Function;
  requestGetExpertiseRaport: Function;
  expertiseReport: ExpertReportType;
  requestValidateExpertReport: Function;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  requestValidateJudgementOnMerits: Function;
  requestValidateDisclaimerWarranty: Function;
  requestGetJudgementOnMerits: Function;
  judgementOnMerits: JudgementOnMeritsType;
  documentId: string;
  setDocumentId: Function;
  judgementAppeal: IAppealPayload;
  requestGetJudgementAppeal: Function;
  requestValidateJudgementAppeal: Function;
  requestGetDahirAmount: Function;
  dahirAmount: [];
  feeNotes: FeeNote[];
  feeNotesCount: number;
  resetUploadDocumentStore: Function;
  requestManagerFeeNotes: Function;
  requestFeeNotesByClaimNumb: Function;
  requestCreateFeeNote: Function;
  requestFeeNoteExceptionalCosts: Function;
  keyclokToken: string | null;
  makeDecisionFeeNote: Function;
  currentTabInstance: string;
  setCurrentInstanceTab: Function;
  requestAllFeeNotes: Function;
  allFeeNote: FeeNote[];
  requestCorporealLawyers: Function;
  corporealLawyers: any;
  requestCreateCivilProceeding: Function;
  requestGetCivilProceeding: Function;
  judiciaryProcessId: number;
  civilProceeding: [];
  requestCreateJudgementOnMerits: Function;
  requestAssignedExpert: Function;
  requestUpdatedCivilProceeding: Function;
  selectedClaim: any;
  requestSagisClaimInfo: Function;
  sagisClaim: any;
  dahirAmountsCorpo: any;
  requestGetDahirAmountCorpo: Function;
  requestCreateJudgementOnMeritsContestation: any;
  requestGetJudgementOnMeritsAppeal: any;
  judgementOnMeritsAppeal: any;
  expertiseRaportAppeal: any;
  requestGetExpertiseReportAppeal: any;
  requestGetJudgementAddAppeal: Function;
  requestValidatedCivilProceeding: Function;
  judgementAddAppeal: any;
  requestMakeJudgementAddDocumentDecision: Function;
  requestAssigment: Function;
  requestAddVictims: Function;
  linkToBeneficiaryCodes: SagisConfig[];
  updateContestation: Function;
  requestUploadContestationDocument: Function;
  requestUpdateVictimInfo: Function;
  requestUpdateBeneficiaryInfo: Function;
  requestUpdateVehicleInfo: Function;
  setClaimRecap: Function;
  requestAddVehicles: Function;
  requestGetJudgementOnMeritsMultiple: Function;
  requestGetAppealOnMeritsMultiple: Function;
  judgementOnMeritsMultiple: any;
  appealOnMeritsMultiple: any;
  requestGetJudgementOnMeritsByVictims: Function;
  judgementOnMeritsByVictims: any;
  requestGetJudgementOnMeritsByVehicles: Function;
  judgementOnMeritsByVehicles: any;
  requestGetExpertiseVictim: Function;
  requestMakeDecisionMissionExpertise: Function;
  requestMakeDecisionMissionNoticeDeficiency: Function;
  requestCreateCorpoEncryptedDocument: Function;
  requestCreateCorporealRegulation: Function;
  requestCreateMaterialRegulation: Function;
  requestCreateAdditionalWarrentiesRegulation: Function;
  corporealEncryptedDocuments: any;
  requestUpdateFeeNoteAmount: Function;
  expertExpertise: any;
  materialEncryptedDocuments: any;
  requestMaterialEncryptedDocument: Function;
  loaders: any;
  requestIsSuspiciosClaim: Function;
  requestCreateJudgementAdd: Function;
  requestGetAssignedLawyers: Function;
  assignedLawyers: AssignedLawyer[];
  requestCreateMultipleJudgementAdd: Function;
  requestCreateExpertiseRaport: Function;
  requestUpdateClaim?: Function;
  currentIndexTabManager: any;
  currentGlobalTabManagerIndex: any;
  currentInstanceTabIndexManager: any;
  currentJudiciaryProccessId: any;
  requestAddSupportDocument: Function;
  requestCivilPartySupportDocument: Function;
  requestAddExpertiseSupportDocument: Function;
  requestAddJudgementOnMeritsSupportDocument: Function;
  requestValidateProvisionIntervenant: Function;
  requestLockClaim: Function;
  requestUnlockClaim: Function;
  setLockedClaim: any;
  requestGetRegulations: Function;
  regulations: any;
  managerNotifcationsInboxes: any;
  resetStoreClaim: Function;
  resetSagisInfoClaim: Function;
  resetLegalProceeding: Function;
  createdRegulations: any;
  requestCreateSummarySheetRegulation: Function;
  uploadDocumentRegulation: Function;
  requestMakeDecisionsDocumentImaging: Function;
  requestGetNotificationsInboxes: Function;
  requestValidateProvision: Function;
  currentTabManagerExpertise: any;
  requestAddInvoiceFeeNote: Function;
  requestUpdateInvoiceFeeNote: Function;
  decisionJudgementIds: any;
  requestGetClaimHistoryActions: Function;
  userActions: any;
  requestUpdateFeeNoteStatus: Function;
  setDecisionsJudgementIds: Function;
  requestGetClaimHistorySagis: Function;
  claimHistorySagis: any;
  requestSetStatusClaimSagis: Function;
  requestResetHistoryStore: Function;
  requestCreateFeeNoteManager: Function;
  requestGetFeeNotesTransaction: Function;
  requestGetTransaction: Function;
  requestAddTransaction: Function;
  resetStoreTransaction: Function;
  requestUpdateTransaction: Function;
  requestAddContactTransaction: Function;
  requestGetContactTransaction: Function;
  requestGetMissionTransaction: Function;
  requestGetMissionVictimExpertise: Function;
  requestUpdateContactTransaction: Function;
  requestUpdateMissionTransaction: Function;
  requestGetReportsPolicy: Function;
  requestGetPendingTasksClaim: Function;
  pendingTasksClaim: any;
  requestGetDocByDocumentumId: Function;
  requestGetJudgements: Function;
  requestUpdateFirmReferenceManager: Function;
  setCurrentIndexTabTransaction: Function;
}

export const ConsultationLegalProceedingPage: React.FC<ConsultationLegalProceedingPageProps> = (
  props,
): JSX.Element => {
  const [isButtonRedirect, setIsButtonRedirect] = useState(false);
  const [openTrackingDrawer, setOpenTrackingDrawer] = useState(false);
  const [page, setPage] = React.useState<number>(0);

  useEffect(() => {
    return () => {
      props.resetSearchClaimsStore();
      props.resetStoreClaim();
      props.requestResetHistoryStore();
    };
  }, []);

  useEffect(() => {
    return () => {
      props.resetSearchClaimsStore();
      props.resetStoreClaim();
      props.resetSagisInfoClaim();
      props.resetLegalProceeding();
      props.requestResetHistoryStore();
    };
  }, []);
  const [OpenDrawerImagineDocuments, setOpenDraweImagineDocuments] = useState(
    false,
  );

  const handleToggleDrawer = () => {
    setOpenDraweImagineDocuments(!isDrawerOpen);
  };

  const handleToggleTrackingDrawer = () => {
    setOpenTrackingDrawer(!openTrackingDrawer);
  };
  const [isDrawerOpen, setDrawerOpen] = React.useState(false);
  const [expandRow, setExpandRow] = useCollapse(
    get(props.listings, 'managerInboxes', []),
  );

  const claimId = props.match.params.claimId;
  const claimNumber = get(props.claimRecap, 'claim.claimNumber', null);

  const [dropDown, setDropDown] = React.useState<null | HTMLElement>(null);
  const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false);
  const [isExpertFeeNote, setIsExpertFeeNote] = React.useState<boolean>(false);

  const [currentRegulationTab, setCurrentRegulationTab] = useState(0);

  const [idCivilProceeding, setIdCivilProceeding] = React.useState<number>(0);

  const [currentJudiciaryProcess, setCurrentJudiciaryProcess] = React.useState<
    any
  >({});
  const [
    isAssignmentClaimDrawerOpen,
    setIsAssignmentClaimDrawerOpen,
  ] = useState<boolean>(false);
  const [isAddVictimCardOpen, setIsAddVictimCardOpen] = useState<boolean>(
    false,
  );
  useEffect(() => {
    const claimId = get(props, ['match', 'params', 'claimId']);
    props.requestGetCivilProceeding(claimId);
  }, [
    claimId,
    props.currentIndexTabManager,
    props.currentGlobalTabManagerIndex,
  ]);

  useEffect(() => {
    if (
      featureService.hasFeature(FEATURES.TRACKING_ACTIONS_USER) &&
      !isNil(claimNumber)
    ) {
      props.requestGetPendingTasksClaim({
        claimNumber: claimNumber,
      });
    }
    if (props.currentJudiciaryProccessId) {
      const claimId = get(props, ['match', 'params', 'claimId']);
      props.requestGetCivilProceeding(claimId);
      props.requestClaimRecap(claimId);
      setIdCivilProceeding(props.currentJudiciaryProccessId);
      if (get(props.civilProceeding, '[0].id')) {
        props.getLegalProceedingsSteps(
          claimId,
          props.currentJudiciaryProccessId,
        );
        props.requestClaimRecap(claimId);
      }
    } else {
      const correctionnelProceeding = props.civilProceeding.filter(
        (element: { procedureNatureId: number }) =>
          element.procedureNatureId === 3,
      );
      const claimId = get(props, ['match', 'params', 'claimId']);
      props.requestGetCivilProceeding(claimId);
      props.requestClaimRecap(claimId);
      setIdCivilProceeding(get(correctionnelProceeding, '[0].id'));
      //setTitleCivilProceeding('Procédure Correctionnelle');
      if (get(props.civilProceeding, '[0].id')) {
        props.getLegalProceedingsSteps(
          claimId,
          get(props.civilProceeding, '[0].id'),
        );
        props.requestClaimRecap(claimId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    claimId,
    claimNumber,
    props.currentIndexTabManager,
    props.currentGlobalTabManagerIndex,
    props.currentJudiciaryProccessId,
  ]);

  const toggleDrawer = () => {
    setDrawerOpen(!isDrawerOpen);
  };
  useEffect(() => {
    props.requestCorporealLawyers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!_.isEmpty(props.corporealLawyers)]);
  useEffect(() => {
    if (claimId) {
      props.requestGetExpertiseVictim({
        missionId: null,
        claimId,
        missionVictimId: null,
        missionVehicleId: null,
        isIntervenant: false,
        isLegalProceeding: true,
      });
    }
  }, [!claimId]);

  const handleOpen = () => {
    props.setDecisionsJudgementIds({});
    setIsExpertFeeNote(false);
    setIsDialogOpen(true);
  };

  const handleOpenAssignment = () => {
    setIsAssignmentClaimDrawerOpen(true);
  };

  const handleOpenExpertiseFeeNote = () => {
    setIsExpertFeeNote(true);
    setIsDialogOpen(true);
  };

  const toggleDrawerAssignmentClaim = () => {
    setIsAssignmentClaimDrawerOpen(!isAssignmentClaimDrawerOpen);
  };

  const toggleAddVictimCard = () => {
    setIsAddVictimCardOpen(!isAddVictimCardOpen);
  };

  const handleClose = () => {
    setIsDialogOpen(false);
    props.setDecisionsJudgementIds({});
  };

  const formatLabel = (
    label: string,
    index: string,
    isProceedingCivil: boolean,
  ) => {
    if (!isProceedingCivil) {
      return label;
    } else {
      return label + ' ' + index;
    }
  };
  const ListProceeding = [
    {
      id: 1,
      title: 'Procédure commerciale',
    },
    {
      id: 2,
      title: 'Procédure civile',
    },
    {
      id: 3,
      title: 'Procédure correctionelle',
    },
  ];

  let labes = _.orderBy(
    props.civilProceeding,
    ['procedureNatureId'],
    ['desc'],
  ).map(
    (
      el: {
        procedureNatureId: number;
        id: number;
        courtNumber: string;
      },
      index,
    ) =>
      formatLabel(
        get(
          ListProceeding.filter(element => element.id === el.procedureNatureId),
          '[0].title',
        ),
        el.courtNumber,
        el.procedureNatureId === 3 ? false : true,
      ),
  );

  let labesWithIds = _.orderBy(
    props.civilProceeding,
    ['procedureNatureId'],
    ['desc'],
  ).map(
    (
      el: {
        procedureNatureId: number;
        id: number;
        courtNumber: string;
      },
      index,
    ) => {
      return {
        id: el.id,
        label: formatLabel(
          get(
            ListProceeding.filter(
              element => element.id === el.procedureNatureId,
            ),
            '[0].title',
          ),
          el.courtNumber,
          el.procedureNatureId === 3 ? false : true,
        ),
      };
    },
  );

  const handleClickVerticalTabs = (tabIndex: number) => {
    const idCivilProceeding = labesWithIds[tabIndex]?.id;
    props.civilProceeding.forEach(
      (el: { procedureNatureId: number; id: number; courtNumber: string }) => {
        if (el.id === idCivilProceeding) {
          setIdCivilProceeding(el.id);
          setCurrentJudiciaryProcess(el);
        }
      },
    );
  };

  const tabs = {
    SUMMARY: {
      id: 0,
      title: translate(messages.courtManagerRecapTitle, props),
      feature: true,
    },
    JUDICIARY_PROCESS: {
      id: 1,
      title: translate(messages.judiciaryProcessTabTitle, props),
      feature: true,
    },
    PROVISION_AND_REGULATION: {
      id: 1,
      title: translate(messages.provisionTab, props),
      feature: featureService.hasFeature(FEATURES.PROVISION),
    },
    EXPERT_INTEGRATION: {
      id: 1,
      title: translate(messages.expertise, props),
      feature: featureService.hasFeature(FEATURES.EXPERT_INTEGRATION),
    },
    TRANSACTION: {
      id: 1,
      title: translate(messages.transactionTabTitle, props),
      feature: featureService.hasFeature(FEATURES.TRANSACTION),
    },
  };

  useEffect(() => {
    if (currentRegulationTab === 0) {
      !isNil(claimNumber) && props.requestSagisClaimInfo(claimNumber);
      claimId && props.requestGetRegulations(claimId);
    }
  }, [currentRegulationTab]);
  const handleResetStore = () => {
    props.resetSearchClaimsStore();
    props.resetStoreClaim();
    props.resetSagisInfoClaim();
    props.resetLegalProceeding();
    props.requestResetHistoryStore();
  };
  const { currentTabIndex, labels = [] } = {
    currentTabIndex:
      props.currentGlobalTabManagerIndex || claimTabs(tabs)?.currentTabIndex,
    labels: claimTabs(tabs)?.labels,
  };

  const isBasicManagementRegulation =
    featureService.hasFeature(FEATURES.BASIC_MANAGEMENT_REGULATION) &&
    get(props.claimRecap, 'claim.isBasicManagement', false) &&
    isEmpty(get(props.judgementOnMeritsByVictims, 'judgement', [])) &&
    isEmpty(
      get(props.judgementOnMeritsByVictims, 'judgementsWithCivjvm', []),
    ) &&
    isEmpty(
      get(props.judgementOnMeritsByVictims, 'judgementprocedureNatureIds', []),
    ) &&
    isEmpty(props.judgementOnMeritsByVehicles);

  return (
    <Container>
      <StyledTopDiv>
        {get(props.claimRecap['claim'], ['suspicious']) &&
          featureService.hasFeature(FEATURES.FRAUDE_CORPO) && (
            <SuspiciousCard />
          )}
        {shouldShowVictimExcludedWarning(
          get(props.claimRecap, 'victims'),
          featureService.hasFeature(FEATURES.IS_VICTIM_EXCLUDED_FROM_COVERAGE),
        ) && (
          <WarningCard
            message={messages.victimExcludedFromCoverageWarningMessage}
          />
        )}
        <TopCard
          claimNumber={get(props.claimRecap['claim'], 'claimNumber', '')}
          claimRecap={props.claimRecap}
          sagisClaim={props.sagisClaim}
          inputProps={{ disableUnderline: true }}
          intl={props.intl}
          setDropDown={setDropDown}
          dropDown={dropDown}
          toggleDrawer={toggleDrawer}
          handleOpenCivilProceeding={() => {}}
          handleOpenDisclaimerWarrantyReasons={() => {}}
          requestSagisClaimInfo={props.requestSagisClaimInfo}
          toggleDrawerAssignmentClaim={toggleDrawerAssignmentClaim}
          toggleAddVictimCard={toggleAddVictimCard}
          assignedLawyer={get(
            props.claimRecap,
            'claim.assignment[0].assignedLawyer',
          )}
          setIsAssignmentDialogOpen={() => {}}
          setOpenIsSuspiciosClaimDialog={() => {}}
          handleToggleImagineDocDrawer={handleToggleDrawer}
          resetSagisInfoClaim={props.resetSagisInfoClaim}
          claimHasCivilPartyJudiciaryProcess={{}}
          handleToggleTrackingDrawer={handleToggleTrackingDrawer}
          requestSetStatusClaimSagis={props.requestSetStatusClaimSagis}
          isConsultation={true}
          isAllDisabled={
            userPrivileges.userHasPrivilege(PRIVILEGES.ISCONSULTATIONMANAGER) ||
            userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER)
          }
          listings={props.listings}
          handleResetStore={handleResetStore}
        />
      </StyledTopDiv>
      {featureService.hasFeature(FEATURES.TRACKING_ACTIONS_USER) && (
        <TrackingActionDrawer
          isDrawerOpen={openTrackingDrawer}
          setIsDrawerOpen={handleToggleTrackingDrawer}
          userActions={props.userActions}
          listings={props.listings}
          claimHistorySagis={props.claimHistorySagis}
          claimNumber={claimNumber}
          claimId={claimId}
          requestGetClaimHistoryActions={props.requestGetClaimHistoryActions}
          requestGetClaimHistorySagis={props.requestGetClaimHistorySagis}
          loaders={props.loaders}
        />
      )}
      {featureService.hasFeature(FEATURES.TRAITEMENT_IMAGINE_DOC) && (
        <ImagineDocumentsDrawer
          claimId={claimId}
          isDrawerOpen={OpenDrawerImagineDocuments}
          setIsDrawerOpen={setOpenDraweImagineDocuments}
          listings={props.listings}
          expandRow={expandRow}
          setExpandRow={setExpandRow}
          claimSagisInfo={resolveSagisClaim(props.policyInfo)}
          managerNotifcationsInboxes={get(
            props.pendingTasksClaim,
            'pendingNotifications',
            [],
          )}
          requestMakeDecisionsDocumentImaging={
            props.requestMakeDecisionsDocumentImaging
          }
          shouldDisplayUploadDocument={false}
          requestGetNotificationsInboxes={props.requestGetNotificationsInboxes}
          isConsultation={true}
          imagineNotification={{}}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      )}

      {featureService.hasFeature(FEATURES.FEE_NOTE) && (
        <DialogFeeNote
          allFeeNote={props.allFeeNote}
          requestAllFeeNotes={props.requestAllFeeNotes}
          feeNotes={filterFeeNotes(
            props.feeNotes,
            isExpertFeeNote,
            props.decisionJudgementIds,
            false,
          )}
          feeNotesCount={props.feeNotesCount}
          requestLawyerFeeNotes={props.requestFeeNotesByClaimNumb}
          requestCreateFeeNote={props.requestCreateFeeNote}
          requestFeeNoteCosts={props.requestFeeNoteExceptionalCosts}
          keyclokToken={props.keyclokToken}
          resetUploadDocumentStore={props.resetUploadDocumentStore}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          setDocumentId={props.setDocumentId}
          documentId={props.documentId}
          makeDecisionFeeNote={props.makeDecisionFeeNote}
          open={isDialogOpen}
          handleClose={handleClose}
          showButtonAdd={false}
          title={translate(messages.FeeNoteTitle, props)}
          claimNumber={get(props.claimRecap, 'claim.claimNumber')}
          listings={props.listings}
          page={page}
          setPage={setPage}
          linkToBeneficiaryCodes={props.linkToBeneficiaryCodes}
          isExpert={isExpertFeeNote}
          requestUpdateFeeNoteAmount={props.requestUpdateFeeNoteAmount}
          loaders={props.loaders}
          requestAddInvoiceFeeNote={props.requestAddInvoiceFeeNote}
          requestUpdateInvoiceFeeNote={props.requestUpdateInvoiceFeeNote}
          requestUpdateFeeNoteStatus={props.requestUpdateFeeNoteStatus}
          contractorFeesSagis={get(props.sagisClaim, 'contractorFees')}
          isManager={false}
          isConsultation={true}
          requestUpdateFirmReferenceManager={
            props.requestUpdateFirmReferenceManager
          }
        />
      )}
      {featureService.hasFeature(FEATURES.ASSIGNMENT_CLAIM) && (
        <>
          <AssignmentClaimDrawer
            open={isAssignmentClaimDrawerOpen}
            handleToggleDrawer={toggleDrawerAssignmentClaim}
            listings={props.listings}
            judiciaryProcess={props.civilProceeding}
            intervenants={get(props.listings, 'intervenants', [])}
            claimRecap={props.claimRecap}
            setIsAssignmentDialogOpen={() => {}}
            setJudiciaryProcessType={() => {}}
            judiciaryProcessId={idCivilProceeding}
            setIsReassignmentManager={() => {}}
            isConsultation={true}
          />
        </>
      )}

      <SahamTabsGlobal>
        <GlobalLegalProceedingTabs
          currentTabIndex={currentTabIndex}
          labels={labels}
          setCurrentInstanceTab={props.setCurrentInstanceTab}
        >
          <ClaimRecap
            listings={props.listings}
            storedClaimToPreopen={props.storedClaimToPreopen}
            requestClaimRecap={props.requestClaimRecap}
            claimRecap={props.claimRecap}
            policyInfo={props.policyInfo}
            requestSearchClaims={props.requestSearchClaims}
            resetSearchClaimsStore={props.resetSearchClaimsStore}
            claimId={claimId as any}
            requestUpdateVictimInfo={props.requestUpdateVictimInfo}
            requestUpdateVehicleInfo={props.requestUpdateVehicleInfo}
            setClaimRecap={props.setClaimRecap}
            requestCreateVehicle={props.requestAddVehicles}
            requestUpdateClaim={props.requestUpdateClaim}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            setDocumentId={props.setDocumentId}
            documentId={props.documentId}
            match={props.match}
            requestRejectClaim={() => {}}
            requestOpenClaim={() => {}}
            requestAssigment={() => {}}
            requestCorporealLawyers={props.requestCorporealLawyers}
            requestOpenMixedClaim={() => {}}
            corporealLawyers={[]}
            openedClaim={undefined}
            requestValidateVehicle={() => {}}
            requestUnlockClaim={() => {}}
            requestLockClaim={() => {}}
            setLockedClaim={() => {}}
            resetStoreClaim={() => {}}
            requestGetReportsPolicy={props.requestGetReportsPolicy}
            requestSagisClaimInfo={props.requestSagisClaimInfo}
            requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          />
          <JudiciaryProcessTabs
            currentTabIndex={
              props.currentJudiciaryProccessId
                ? _.orderBy(
                    props.civilProceeding,
                    ['procedureNatureId'],
                    ['desc'],
                  )
                    .map((el: { id: number }) => el.id)
                    .indexOf(
                      Number(props.currentJudiciaryProccessId as any) as any,
                    )
                : 0
            }
            labels={labes}
            handleClickVerticalTabs={handleClickVerticalTabs}
          >
            {labes.map((label, index) => {
              return (
                <ManagerLegalProceedingsPage
                  currentJudiciaryProcess={
                    currentJudiciaryProcess
                      ? currentJudiciaryProcess
                      : props.currentJudiciaryProccessId
                  }
                  listings={props.listings}
                  onPressFeeNote={handleOpen}
                  onPressAssignment={handleOpenAssignment}
                  storedClaimToPreopen={props.storedClaimToPreopen}
                  requestClaimRecap={props.requestClaimRecap}
                  getLegalProceedingsSteps={props.getLegalProceedingsSteps}
                  claimRecap={props.claimRecap}
                  currentSteps={props.currentSteps}
                  policyInfo={props.policyInfo}
                  requestSearchClaims={props.requestSearchClaims}
                  resetSearchClaimsStore={props.resetSearchClaimsStore}
                  match={props.match}
                  requestGetJudgementAdd={props.requestGetJudgementAdd}
                  judgementAdd={props.judgementAdd}
                  requestGetJudgementAddAppeal={
                    props.requestGetJudgementAddAppeal
                  }
                  judgementAddAppeal={props.judgementAddAppeal}
                  requestMakeJudgementAddDecision={
                    props.requestMakeJudgementAddDecision
                  }
                  requestGetExpertiseRaport={props.requestGetExpertiseRaport}
                  expertiseReport={props.expertiseReport}
                  requestValidateExpertReport={
                    props.requestValidateExpertReport
                  }
                  uploadDocument={props.uploadDocument}
                  uploadedDocument={props.uploadedDocument}
                  resetUploadedDocument={props.resetUploadDocumentStore}
                  requestValidateJudgementOnMerits={
                    props.requestValidateJudgementOnMerits
                  }
                  requestGetJudgementOnMerits={
                    props.requestGetJudgementOnMerits
                  }
                  requestGetJudgementOnMeritsAppeal={
                    props.requestGetJudgementOnMeritsAppeal
                  }
                  judgementOnMeritsAppeal={props.judgementOnMeritsAppeal}
                  expertiseRaportAppeal={props.expertiseRaportAppeal}
                  requestGetExpertiseReportAppeal={
                    props.requestGetExpertiseReportAppeal
                  }
                  judgementOnMerits={props.judgementOnMerits}
                  documentId={props.documentId}
                  setDocumentId={props.setDocumentId}
                  judgementAppeal={props.judgementAppeal}
                  requestGetJudgementAppeal={props.requestGetJudgementAppeal}
                  requestValidateJudgementAppeal={
                    props.requestValidateJudgementAppeal
                  }
                  requestGetDahirAmount={props.requestGetDahirAmount}
                  dahirAmount={props.dahirAmount}
                  feeNotes={props.feeNotes}
                  feeNotesCount={props.feeNotesCount}
                  resetUploadDocumentStore={props.resetUploadDocumentStore}
                  requestManagerFeeNotes={props.requestManagerFeeNotes}
                  requestFeeNotesByClaimNumb={props.requestFeeNotesByClaimNumb}
                  requestCreateFeeNote={props.requestCreateFeeNote}
                  keyclokToken={props.keyclokToken}
                  makeDecisionFeeNote={props.makeDecisionFeeNote}
                  currentTabInstance={props.currentTabInstance}
                  setCurrentInstanceTab={props.setCurrentInstanceTab}
                  requestAllFeeNotes={props.requestAllFeeNotes}
                  allFeeNote={props.allFeeNote}
                  requestCorporealLawyers={props.requestCorporealLawyers}
                  corporealLawyers={props.corporealLawyers}
                  requestCreateCivilProceeding={
                    props.requestCreateCivilProceeding
                  }
                  requestGetCivilProceeding={props.requestGetCivilProceeding}
                  judiciaryProcessId={
                    idCivilProceeding
                      ? idCivilProceeding
                      : props.currentJudiciaryProccessId
                  }
                  civilProceeding={props.civilProceeding}
                  requestCreateJudgementOnMerits={
                    props.requestCreateJudgementOnMerits
                  }
                  requestUpdatedCivilProceeding={
                    props.requestUpdatedCivilProceeding
                  }
                  requestSagisClaimInfo={props.requestSagisClaimInfo}
                  sagisClaim={props.sagisClaim}
                  requestGetDahirAmountCorpo={props.requestGetDahirAmountCorpo}
                  dahirAmountsCorpo={props.dahirAmountsCorpo}
                  requestCreateJudgementOnMeritsContestation={
                    props.requestCreateJudgementOnMeritsContestation
                  }
                  requestValidatedCivilProceeding={
                    props.requestValidatedCivilProceeding
                  }
                  requestMakeJudgementAddDocumentDecision={
                    props.requestMakeJudgementAddDocumentDecision
                  }
                  updateContestation={props.updateContestation}
                  requestUploadContestationDocument={
                    props.requestUploadContestationDocument
                  }
                  requestUpdateVictimInfo={props.requestUpdateVictimInfo}
                  requestUpdateBeneficiaryInfo={
                    props.requestUpdateBeneficiaryInfo
                  }
                  requestUpdateVehicleInfo={props.requestUpdateVehicleInfo}
                  setClaimRecap={props.setClaimRecap}
                  requestAddVictims={props.requestAddVictims}
                  requestGetAppealOnMeritsMultiple={
                    props.requestGetAppealOnMeritsMultiple
                  }
                  requestGetJudgementOnMeritsMultiple={
                    props.requestGetJudgementOnMeritsMultiple
                  }
                  appealOnMeritsMultiple={props.appealOnMeritsMultiple}
                  judgementOnMeritsMultiple={props.judgementOnMeritsMultiple}
                  judgementOnMeritsByVictims={props.judgementOnMeritsByVictims}
                  requestGetJudgementOnMeritsByVictims={
                    props.requestGetJudgementOnMeritsByVictims
                  }
                  judgementOnMeritsByVehicles={
                    props.judgementOnMeritsByVehicles
                  }
                  requestGetJudgementOnMeritsByVehicles={
                    props.requestGetJudgementOnMeritsByVehicles
                  }
                  expertExpertise={props.expertExpertise}
                  requestMakeDecisionMissionExpertise={
                    props.requestMakeDecisionMissionExpertise
                  }
                  loaders={props.loaders}
                  requestCreateJudgementAdd={props.requestCreateJudgementAdd}
                  requestCreateMultipleJudgementAdd={
                    props.requestCreateMultipleJudgementAdd
                  }
                  requestCreateExpertiseRaport={
                    props.requestCreateExpertiseRaport
                  }
                  currentIndexTabManager={props.currentIndexTabManager}
                  currentInstanceTabIndexManager={
                    props.currentInstanceTabIndexManager
                  }
                  currentJudiciaryProccessId={props.currentJudiciaryProccessId}
                  requestAddSupportDocument={props.requestAddSupportDocument}
                  requestCivilPartySupportDocument={
                    props.requestCivilPartySupportDocument
                  }
                  requestAddExpertiseSupportDocument={
                    props.requestAddExpertiseSupportDocument
                  }
                  requestAddJudgementOnMeritsSupportDocument={
                    props.requestAddJudgementOnMeritsSupportDocument
                  }
                  currentGlobalTabManagerIndex={
                    props.currentGlobalTabManagerIndex
                  }
                  setIsButtonRedirect={setIsButtonRedirect}
                  isButtonRedirect={isButtonRedirect}
                  setOpenFeeNoteDialog={setIsDialogOpen}
                  requestGetReportsPolicy={props.requestGetReportsPolicy}
                  requestGetClaimCivilParty={() => {}}
                  requestGetDocByDocumentumId={
                    props.requestGetDocByDocumentumId
                  }
                  requestGetJudgements={props.requestGetJudgements}
                />
              );
            })}
          </JudiciaryProcessTabs>
          {get(tabs['PROVISION_AND_REGULATION'], 'feature', false) && (
            <main>
              <LegalProceedingTabs
                labels={PROVISION_TAB_LABELS}
                currentTabIndex={0}
              >
                <ProvisionContainer
                  claimNumber={claimNumber}
                  listings={props.listings}
                  requestSagisClaimInfo={props.requestSagisClaimInfo}
                  sagisClaim={props.sagisClaim}
                  setIsDetail={() => {}}
                  requestValidateProvisionIntervenant={
                    props.requestValidateProvisionIntervenant
                  }
                  claimId={claimId}
                  isConsultation={true}
                  lossDate={get(props.claimRecap, 'claim.lossDate')}
                  uploadedDocument={props.uploadedDocument}
                  resetUploadDocumentStore={props.resetUploadDocumentStore}
                  uploadDocument={props.uploadDocument}
                  requestCreateFeeNoteManager={
                    props.requestCreateFeeNoteManager
                  }
                />
                <LegalProceedingTabs
                  labels={REGULATION_TAB_LABELS_CONSULTATION}
                  currentTabIndex={currentRegulationTab}
                  setCurrentInstanceTab={setCurrentRegulationTab}
                >
                  <div>
                    <RegulationRecapContainer
                      sagisClaim={props.sagisClaim}
                      listings={props.listings}
                      regulations={props.regulations}
                      isConsultation={true}
                      claimId={claimId}
                      isBasicManagementRegulation={isBasicManagementRegulation}
                    />
                    <></>
                  </div>
                </LegalProceedingTabs>
              </LegalProceedingTabs>
            </main>
          )}
          {get(tabs['EXPERT_INTEGRATION'], 'feature', false) && (
            <ExpertiseExpert
              match={props.match}
              requestMakeDecisionMissionExpertise={
                props.requestMakeDecisionMissionExpertise
              }
              requestMakeDecisionMissionNoticeDeficiency={
                props.requestMakeDecisionMissionNoticeDeficiency
              }
              requestFeeNotesByClaimNumb={props.requestFeeNotesByClaimNumb}
              claimNumber={claimNumber}
              onPressFeeNote={handleOpenExpertiseFeeNote}
              currentTabManagerExpertise={props.currentTabManagerExpertise}
              isLawyer={true}
              riskKey={get(
                get(props.sagisClaim, 'offeredRisks', []).find(
                  (element: { riskName: string }) =>
                    element.riskName === rcCoporeal,
                ),
                'riskId',
              )}
              setOpenFeeNoteDialog={() => {}}
              claimRecap={props.claimRecap}
              resetSearchClaimsStore={props.resetSearchClaimsStore}
              resetStoreClaim={props.resetStoreClaim}
              resetSagisInfoClaim={props.resetSagisInfoClaim}
              resetLegalProceeding={props.resetLegalProceeding}
              policyInfo={props.policyInfo}
              currentIndexTabManager={props.currentIndexTabManager}
              currentInstanceTabIndexManager={
                props.currentInstanceTabIndexManager
              }
              currentTabInstance={props.currentTabInstance}
              requestSearchClaims={props.requestSearchClaims}
              listings={props.listings}
              requestGetExpertiseVictim={props.requestGetExpertiseVictim}
              requestSetPriorityClaimProvision={undefined}
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
            />
          )}
          {get(tabs['TRANSACTION'], 'feature', false) && (
            <TransactionConsultation
              match={props.match}
              claimNumber={claimNumber}
              claimRecap={props.claimRecap}
              policyInfo={props.policyInfo}
              requestGetTransaction={props.requestGetTransaction}
              requestAddTransaction={props.requestAddTransaction}
              uploadedDocument={props.uploadedDocument}
              resetUploadedDocument={props.resetUploadDocumentStore}
              uploadDocument={props.uploadDocument}
              requestUpdateTransaction={props.requestUpdateTransaction}
              requestAddContactTransaction={props.requestAddContactTransaction}
              requestGetContactTransaction={props.requestGetContactTransaction}
              resetStoreTransaction={props.resetStoreTransaction}
              requestUpdateContactTransaction={
                props.requestUpdateContactTransaction
              }
              corporealExperts={[]}
              requestGetExpertUsers={() => {}}
              requestAssignedExpert={props.requestAssignedExpert}
              riskKey={get(
                get(props.sagisClaim, 'offeredRisks', []).find(
                  (element: { riskName: string }) =>
                    element.riskName === rcCoporeal,
                ),
                'riskId',
              )}
              requestGetMissionTransaction={props.requestGetMissionTransaction}
              requestMakeDecisionMissionExpertise={
                props.requestMakeDecisionMissionExpertise
              }
              requestGetMissionVictimExpertise={
                props.requestGetMissionVictimExpertise
              }
              requestUpdateMissionTransaction={
                props.requestUpdateMissionTransaction
              }
              requestGetFeeNotesTransaction={
                props.requestGetFeeNotesTransaction
              }
              onPressFeeNote={() => {}}
              isConsultation={true}
              expertJudiciaryExpertise={props.expertExpertise}
              requestImportMissionExpertise={() => {}}
              requestGetJudiciaryExpertReport={() => {}}
              sagisInfo={props.sagisClaim}
              requestMakeDecisionVictimInfo={() => {}}
              requestLockClaim={props.requestLockClaim}
              setLockedClaim={props.setLockedClaim}
              requestSetPriorityClaimProvision={() => {}}
              requestResetHistoryStore={props.requestResetHistoryStore}
              currentIndexTabManager={props.requestResetHistoryStore}
              currentInstanceTabIndexManager={
                props.currentInstanceTabIndexManager
              }
              currentGlobalTabManagerIndex={props.currentGlobalTabManagerIndex}
              currentJudiciaryProccessId={props.currentJudiciaryProccessId}
              requestGetDahirAmount={props.requestGetDahirAmount}
              requestCreateCorporealRegulation={() => {}}
              requestGetRegulations={props.requestGetRegulations}
              regulations={props.regulations}
              requestSagisClaimInfo={props.requestSagisClaimInfo}
              requestGetRegulation={() => {}}
              requestValidateRegulation={() => {}}
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
              setCurrentIndexTabTransaction={
                props.setCurrentIndexTabTransaction
              }
            />
          )}
        </GlobalLegalProceedingTabs>
      </SahamTabsGlobal>
    </Container>
  );
};

const mapDispatchToProps = {
  requestUpdateVictimInfo,
  requestClaimRecap,
  requestSearchClaims,
  getLegalProceedingsSteps,
  resetSearchClaimsStore,
  requestGetJudgementAdd,
  requestMakeJudgementAddDecision,
  requestGetExpertiseRaport,
  requestValidateExpertReport,
  requestValidateJudgementOnMerits,
  requestGetJudgementOnMerits,
  requestGetJudgementOnMeritsAppeal,
  requestGetExpertiseReportAppeal,
  uploadDocument,
  resetUploadDocumentStore,
  requestGetJudgementAppeal,
  requestValidateJudgementAppeal,
  requestGetDahirAmount,
  setDocumentId,
  requestManagerFeeNotes,
  requestCreateFeeNote,
  requestFeeNoteExceptionalCosts,
  requestFeeNotesByClaimNumb,
  makeDecisionFeeNote,
  setCurrentInstanceTab,
  requestAllFeeNotes,
  requestCorporealLawyers,
  requestCreateCivilProceeding,
  requestGetCivilProceeding,
  requestGetJudgementAddAppeal,
  requestCreateJudgementOnMerits,
  requestAssignedExpert,
  requestValidateDisclaimerWarranty,
  requestUpdatedCivilProceeding,
  requestValidatedCivilProceeding,
  requestSagisClaimInfo,
  requestGetDahirAmountCorpo,
  requestCreateJudgementOnMeritsContestation,
  requestMakeJudgementAddDocumentDecision,
  requestAssigment,
  requestAddVictims,
  updateContestation,
  requestUploadContestationDocument,
  requestUpdateBeneficiaryInfo,
  requestUpdateVehicleInfo,
  setClaimRecap,
  requestAddVehicles,
  requestGetAppealOnMeritsMultiple,
  requestGetJudgementOnMeritsMultiple,
  requestGetJudgementOnMeritsByVictims,
  requestGetJudgementOnMeritsByVehicles,
  requestGetExpertiseVictim,
  requestMakeDecisionMissionExpertise,
  requestMakeDecisionMissionNoticeDeficiency,
  requestCreateCorpoEncryptedDocument,
  requestCreateCorporealRegulation,
  requestCreateMaterialRegulation,
  requestCreateAdditionalWarrentiesRegulation,
  requestUpdateFeeNoteAmount,
  requestMaterialEncryptedDocument,
  requestIsSuspiciosClaim,
  requestCreateJudgementAdd,
  requestGetAssignedLawyers,
  requestCreateMultipleJudgementAdd,
  requestCreateExpertiseRaport,
  requestUpdateClaim,
  requestAddSupportDocument,
  requestCivilPartySupportDocument,
  requestAddExpertiseSupportDocument,
  requestAddJudgementOnMeritsSupportDocument,
  requestValidateProvisionIntervenant,
  requestLockClaim,
  requestUnlockClaim,
  setLockedClaim,
  requestGetRegulations,
  resetStoreClaim,
  resetSagisInfoClaim,
  resetLegalProceeding,
  requestCreateSummarySheetRegulation,
  uploadDocumentRegulation,
  requestMakeDecisionsDocumentImaging,
  requestGetNotificationsInboxes,
  requestAddInvoiceFeeNote,
  requestValidateProvision,
  requestUpdateInvoiceFeeNote,
  requestGetClaimHistoryActions,
  requestUpdateFeeNoteStatus,
  setDecisionsJudgementIds,
  requestGetClaimHistorySagis,
  requestSetStatusClaimSagis,
  requestResetHistoryStore,
  requestCreateFeeNoteManager,
  requestGetFeeNotesTransaction,
  requestGetTransaction,
  requestAddTransaction,
  resetStoreTransaction,
  requestUpdateTransaction,
  requestAddContactTransaction,
  requestGetContactTransaction,
  requestGetMissionTransaction,
  requestGetMissionVictimExpertise,
  requestUpdateContactTransaction,
  requestUpdateMissionTransaction,
  requestGetReportsPolicy,
  requestGetPendingTasksClaim,
  requestGetDocByDocumentumId,
  requestGetJudgements,
  requestUpdateFirmReferenceManager,
  setCurrentIndexTabTransaction,
};

const mapStateToProps = createStructuredSelector({
  listings: makeSelectListings(),
  claimRecap: makeSelecClaimRecap(),
  policyInfo: makeSelectSearchClaims(),
  uploadedDocument: makeSelectDocument(),
  judgementAdd: makeSelectJudgementAdd(),
  currentSteps: makeSelectLegalProceedingsSteps(),
  expertiseReport: makeSelectExpertiseRaport(),
  judgementAddAppeal: makeSelectJudgementAddAppeal(),
  expertiseRaportAppeal: makeSelectExpertiseRaportAppeal(),
  judgementOnMerits: makeSelectJudgementOnMerits(),
  judgementOnMeritsAppeal: makeSelectJudgementOnMeritsAppeal(),
  judgementAppeal: makeSelectJudgementAppeal(),
  dahirAmount: makeSelectDahirAmounts(),
  documentId: makeSelectDocumentId(),
  feeNotes: makeSelectFeeNotes(),
  feeNotesCount: makeSelectCountFeeNotes(),
  keyclokToken: makeSelectKeycloakToken(),
  currentTabInstance: makeSelectCurrentInstanceTab(),
  allFeeNote: makeSelectAllFeeNotes(),
  corporealLawyers: makeSelectCorporealLawyers(),
  civilProceeding: makeSelectCivilProceeding(),
  sagisClaim: makeSelectSagisClaim(),
  dahirAmountsCorpo: makeSelectDahirAmountsCorpo(),
  linkToBeneficiaryCodes: makeSelectLinkToBeneficiaryCodes(),
  judgementOnMeritsMultiple: makeSelectJudgementOnMeritsMultiple(),
  appealOnMeritsMultiple: makeSelectAppealOnMeritsMultiple(),
  judgementOnMeritsByVictims: makeSelectJudgementOnMeritsByVictims(),
  judgementOnMeritsByVehicles: makeSelectJudgementOnMeritsByVehicles(),
  corporealEncryptedDocuments: makeSelectEncryptedDocuments(),
  materialEncryptedDocuments: makeSelectMaterialEncryptedDocuments(),
  expertExpertise: makeSelectVictimExpertise(),
  loaders: selectedLoader,
  assignedLawyers: makeSelectAssignedLawyers(),
  currentIndexTabManager: makeSelectCurrentTabManager(),
  currentGlobalTabManagerIndex: makeSelectGlobalCurrentTabManager(),
  currentJudiciaryProccessId: makeSelectCurrentTabJudiciaryProcessManager(),
  regulations: makeRegulations(),
  createdRegulations: makeCreatedRegulations(),
  managerNotifcationsInboxes: makeSelectNotificationsInboxes(),
  currentTabManagerExpertise: makeSelectCurrentTabIndexExpertise(),
  decisionJudgementIds: makeSelectDecisionJudgmentIds(),
  claimHistoryActions: makeSelectClaimHistoryActions(),
  userActions: makeSelectClaimHistoryActions(),
  claimHistorySagis: makeSelectClaimHistorySagis(),
  pendingTasksClaim: makeSelectPendingTasksClaim(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ConsultationLegalProceedingPage));
